import React from 'react';
import { Typography } from '@fiverr-private/typography';
import { Container } from '@fiverr-private/layout_components';
import {
    type BlockedActionType,
    useIdentificationContext,
    useImageLoading,
    SkeletonLoading,
} from '@fiverr-private/identification_core';
import { appTranslate, CopyKey } from '../../../i18n';
import { responsiveImg } from '../../../shared/styles/index.ve.css';
import {
    BANNER_ACTION_TYPE_COPY_KEY_MAP,
    BANNER_ACTION_COLOR_CLASS_MAP,
    BANNER_IMAGE_MAP,
} from './BlockedActionBanner.constants';

interface BlockedActionProps {
    blockedActionType: Exclude<BlockedActionType, 'new_brief_and_match'>;
}

export const BlockedActionBanner = ({ blockedActionType }: BlockedActionProps) => {
    const image = BANNER_IMAGE_MAP[blockedActionType];
    const { loading, onLoad } = useImageLoading(image);
    const { mode } = useIdentificationContext();
    const signUpMode = mode === 'sign_up';
    const blockedActionPrefix = signUpMode
        ? 'identification.banner.blocked_action_title_when_sign_up'
        : 'identification.banner.blocked_action_title_when_sign_in';
    const copyKey = `${blockedActionPrefix}.${BANNER_ACTION_TYPE_COPY_KEY_MAP[blockedActionType]}` satisfies CopyKey;

    return (
        <SkeletonLoading loading={loading}>
            <Container position="relative" height="100%" width="100%">
                <Container width="100%" paddingY="14" paddingX="12" position="absolute">
                    <Typography as="h1" color="white" fontWeight="bold" size="h_xxl">
                        {appTranslate(copyKey, {
                            templates: {
                                accent: (text?: string) => (
                                    <Typography as="span" color={BANNER_ACTION_COLOR_CLASS_MAP[blockedActionType]}>
                                        {text}
                                    </Typography>
                                ),
                            },
                        })}
                    </Typography>
                </Container>

                <img
                    onLoad={onLoad}
                    alt={appTranslate<string>('identification.banner.image_alt')}
                    className={responsiveImg}
                    src={image}
                />
            </Container>
        </SkeletonLoading>
    );
};
